import { PrintMap } from "esdm-map/dist/map/tools/PrintMap";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "esdm-map/dist/map/tools/DownloadMapPng";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/tools/MapContextMenu";
import { ToolTipProvider } from "esdm-map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { FeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/FeatureAdd";
import { MapListRecordsInViewport } from "esdm-map/dist/map/MapListRecordsInViewport";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";
import { GeoLocation } from "esdm-map/dist/map/geolocation/geolocation";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";
import { MapViewSettingsUrlProvider } from "esdm-map/dist/map/store/MapViewSettingsUrlProvider";
import { IMapViewPermaLink } from "esdm-map/dist/map/tools/IMapViewPermaLink";
import { MapViewPermaLink } from "esdm-map/dist/map/tools/MapViewPermaLink";
import { FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { IMapViewSettingProvider } from "esdm-map/dist/map/store/IMapViewSettingsProvider";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";

import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapListRecordItem,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger,
    MapFeatureInfo
} from "esdm-map";

import "../wwwroot/css/ol.css";
import "../wwwroot/css/ol3-contextmenu.css";
import "../wwwroot/css/bootstrap-slider.min.css"
import { TextPackLoader, TextPacks } from "./TextPackLoader";

import { MapBase } from "./MapBase";
import { MapToolTip, ToolTipOptions } from "esdm-map/dist/map/tooltip";
import { IDragPan } from "esdm-map/dist/map/controls/interfaces/IDragPan";
import { DragPan } from "esdm-map/dist/map/controls/DragPan";
import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { LhlpIdentity, LhlpUser } from "./defs/LhlpUser";
import { DefaultLayerConfigurationFactory } from "./config/DefaultLayerConfigurationFactory";
import { LhlpStyleFactory } from "./style/LhlpStyleFactory";
import { LhlpResourcefactory } from "./resources/LhlpResourceFactory";
import { DefaultMapOptions } from "./config/DefaultMapOptions";
import { LhlpRecordSubType, LhlpRecordType } from "./defs/LhlpRecordType";
import { LhlpMapListRecordItem } from "./resources/LhlpMapListRecordItem";
import { IWmsLayerGroupConfig } from "esdm-map/dist/layers/groups/wms/interfaces/IWmsLayerGroupConfig";
import { IWmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms/interfaces/IWmsLayerGroupFactory";
import { WmsLayerGroupFactory } from "esdm-map/dist/layers/groups/wms";
import { LhlpBaseLayerFactory } from "./Layers/LhlpBaseLayerFactory";
import { LhlpGazetteer } from "./gazetteer/LhlpGazetteer";
import { LhlpMapConfig, LhlpStatusLookup, LhlpTypeLookup } from "./defs/LhlpMapConfig";
import { FilteredGeoJsonFeatureLoader } from "./loaders/FilteredGeoJsonFeatureLoader";

$(document).ready(function () {  

    $('[data-bs-toggle="tooltip"]').tooltip();          
    let printOptions: PrintMap = new PrintMap();

    if (!printOptions.isPrintMap) {        
        resizeMap();
        $(window).bind('resize', function () { resizeMap(); });
    } 

    function resizeMap() {
        //use max footer height, especially on mobile
        var fHeight = $("footer").height();
        fHeight = Math.min(fHeight, 200);

        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);
        $("#slide-content").height(height - 55);
    };

    let ele = $("#theMap");
    if (ele.length === 1) {      
        LhlpIdentity.fetch().then(function (e) {
            //let user = e;
            //if (e) {
            //    console.log(e.userId);
            //} else {
            //    console.log("401 - UnAuthorised");
            //}
            loadMap(e);
        });
    } 

    function loadMap(user: LhlpUser) {

        let maxFeatureCount: number = <number>ele.data("max-feature-count");
        let siteId: string = <string>ele.data("site-id");
        let siteFolder: string = <string>ele.data("site-folder");
        let mapConfigB64: string = <string>ele.data("map-config");

        let mapConfig: LhlpMapConfig = new LhlpMapConfig();
        if(mapConfigB64) {
            var json: string = atob(mapConfigB64);
            if(json) mapConfig = JSON.parse(json);
            console.log(mapConfig);
        }

        let init = function (textpacks: TextPacks) {
            let map = new MainMap(
                "theMap",
                maxFeatureCount,
                printOptions,
                textpacks.mapping,
                user,
                siteId,
                siteFolder,
                mapConfig
            );

        }
        TextPackLoader.load().then(init);
    }

});

import * as olProj from 'ol/proj';
import Feature from "ol/Feature";
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import { Vector as VectorLayer} from 'ol/layer';
import {Icon, Text, Style, Fill, Stroke, Circle} from 'ol/style';
import IconAnchorUnits from "ol/style/IconAnchorUnits";
import { IFeaturesSelectedEventArgs } from "esdm-map/dist/map/events/IFeaturesSelectedEventArgs";
import CircleStyle from "ol/style/Circle";
import { touchOnly } from "ol/events/condition";
import { LhlpMapContextMenu } from "./contextmenu/LhlpMapContextMenu";
import { IVectorLayer } from "esdm-map/dist/layers/vector/interfaces/IVectorLayer";
import { IAppStorage } from "esdm-map/dist/storage/IAppStorage";
import { AppStorage } from "esdm-map/dist/storage/AppStorage";
import { IVectorLayerGroupLoadedEventArgs } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupEvents";

export class MainMap extends MapBase {
        
    private mfOptions: MapOptions;
    public  map: IMap;
    private mapStore: IMapViewStore;
    private ls: MapLayerSwitcher;
    private infoPopup: MapFeatureInfo;
    private initialised: boolean = false;
    private layerGroups: LayerGroupCollections;
    private styleFactory: IStyleFactory;
    private herMask: IMapAreaMask;   
    private gridRefFinder: GridRef;
    private logger: ILogger;   
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private wmsLayerGroupFactory: IWmsLayerGroupFactory;
    private layerGroupFactory: LayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;    
    private downloadPng: DownloadMapPng;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private recordList: MapListRecordsInViewport;
    private geoLocation: GeoLocation;
    private extentsNavigation: ExtentsNavigation;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private mapViewSettingProvider: MapViewSettingsUrlProvider;
    private mapListRecordItem: IMapListRecordItem;
    private mapViewPermaLink: IMapViewPermaLink;
    private mousePosition: MousePosition;
    private mapToolTip: MapToolTip;   
    private openNames: LhlpGazetteer;
    private storage: IAppStorage;

    public constructor(
        public mapElementId: string,       
        public maxFeatureCount: number,
        public printOptions: IPrintOptions,
        mappingTextPack: IMappingTextPack,
        user: LhlpUser,
        public siteId: string,
        public siteFolder: string,
        public mapConfig: LhlpMapConfig)
    {
        super(mappingTextPack, user);
        this.storage = new AppStorage();
        this.init();
    }

    // has a supplied specific asset_id been identified and scrolled-to?
    private singleAssetSelected: boolean = false;
    private selectedSingleAsset: Feature;

    private init = (): void => {
        let _self = this;

        if (!this.initialised) {
            //strip-loader should take this out for production
            console.log("Initialising main map");                       

            this.layerConfigFactory = new DefaultLayerConfigurationFactory(this.siteId, this.siteFolder, this.mapConfig);
            this.vectorLayerGroupFactory = new VectorLayerGroupFactory(); 
            this.wmsLayerGroupFactory = new WmsLayerGroupFactory();
            this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, this.wmsLayerGroupFactory);
            this.baseLayerFactory = new LhlpBaseLayerFactory();
            this.featureLoader = new FilteredGeoJsonFeatureLoader();
         
            this.featureAdd = new FeatureAdd();

            this.mapFilter = new MapFilters();
            this.mapFilter.OgcFilter = new OgcMapFilter();
            this.mapFactory = new MapFactory();
            this.logger = new Logger();           
            this.styleFactory = new LhlpStyleFactory(this.mapConfig);
            this.resourcefactory = new LhlpResourcefactory(this.mappingTextPack);

            this.mfOptions = DefaultMapOptions.GetDefaultOptions(this.mapElementId, `${this.siteFolder}_MainMap`, this.tenantSettings?.MapSettings);           
            this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
            this.mfOptions.layerGroupCollection = this.layerGroups;
            
            this.mapViewSettingProvider = new MapViewSettingsUrlProvider();
            this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey, this.mapViewSettingProvider);

            this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);
            //this.herMask = new YorkHerBoundary();
            this.mapContextMenu = new LhlpMapContextMenu(this.mappingTextPack);
                        
            this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);

            // passing in an asset id on query string - make sure its layers get loaded
            // by setting them true in the mapstore
            this.activateLayersForSpecifiedAssetType();

            this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);                        

            this.infoPopup = new MapFeatureInfo(this.map, this.resourcefactory.getRecordTypeResource(), this.mappingTextPack);

            this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack,
                {
                    showOpenPanelByDefault: false,
                    showList: false,
                    rememberActivePanel: true
                });
            this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
            this.openNames = new LhlpGazetteer(this.map, this.tenantSettings?.MapSettings.GazetteerApiKey,this.mappingTextPack);

            if (this.printOptions.isPrintMap) {                
                this.printOptions.setMap(this.map);
            } 

            // this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);
            this.mapListRecordItem = new LhlpMapListRecordItem(this.mappingTextPack);
            this.recordList = new MapListRecordsInViewport(this.map, this.mapStore, this.styleFactory, this.layerGroups.vectorLayerGroups, this.mappingTextPack, 13, this.mapListRecordItem);
            this.geoLocation = new GeoLocation(this.map, this.logger, this.mappingTextPack);
            // this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
            this.mousePosition = new MousePosition(this.map, this.mappingTextPack, "EPSG:27700");
            // this.mapViewPermaLink = new MapViewPermaLink(this.map, this.mapViewSettingProvider, this.mappingTextPack, { activePanel: "overlays" });

            if(!window.matchMedia("(pointer: coarse)").matches) {
                //add tooltip if not a touch screen
                this.mapToolTip = new MapToolTip(this.map, new ToolTipProvider(), new ToolTipOptions(10));
            }            
            
            this.initCreateAsset();
            this.infoPopup.onFeaturesSelected.subscribe(this.setSelectedFeaturesDynamicStyle);


            // ----------------------------
            // -----  status filters #773 ------
            
            // we may have an extra panel of status filters...
            // so append them immediately above the other layer filters
            // to prevent UI scrollbar nastiness
            if ($("#extraPanelOverlays").length > 0)
                $("#extraPanelOverlays").prependTo("#panelOverlays");

            // changing a status filter needs to reload the layers
            // and also update its (de-)selected value to local storage
            $(".StatusFilter").on("change", function (event) {
                _self.applyStatusFilters();
                _self.storeStatusFilters();
            });

            /// read local storage to set selected checkboxes on first UI render
            this.initialiseStatusFilters();


            // ----------------------------
            // -----  panning to a pre-specified asset #637 ------

            // Needing to wait until we know all layer groups are loaded, 
            // before then trying to pan to a specific asset...

            let layerGroupsLoading = false;
            let counter = 0;

            this.layerGroups.vectorLayerGroups.forEach((lg) => {
                lg.onLayerGroupLoading.subscribe(() => {
                    layerGroupsLoading = true;
                    counter++;
                });
            });

            this.layerGroups.vectorLayerGroups.forEach((lg) => {
                lg.onLayerGroupLoaded.subscribe(() => {
                    counter--;
                    if (counter == 0 && layerGroupsLoading) {
                        this.afterLoadingFinalLayerGroup();
                        layerGroupsLoading = false;
                    }
                });
            });

            // ----------------------------
            // jk - take away the selected asset's style if we click on another one

            this.infoPopup.onFeaturesSelected.subscribe((args) => {
                if (this.selectedSingleAsset != null) {

                    let selectedId: string = this.selectedSingleAsset.getId().toString();

                    if (args.features.find(f => f.getId() == selectedId) == undefined)
                        this.revertStyle(this.selectedSingleAsset);
                }
            });

            // ----------------------------

            this.initialised = true;
        }
    }


    ////////////////////////////////////////////////////////////////////////////
    // jk - when passing in a specified asset id (and then selecting it on map load)
    // we want to make sure that the vector layer for that asset has already been loaded.
    // So toggle the boolean display properties for the layers in the mapstore storage
    // before it gets used to decide what to load.
    private activateLayersForSpecifiedAssetType = (): void => {
        
        let scrolltoAssetTypeId: number = + $('#scrollToAssetType').val();

        if (!isNaN(scrolltoAssetTypeId) && scrolltoAssetTypeId > 0) {
            switch (scrolltoAssetTypeId.toString()) {
                case LhlpRecordSubType.AssetTypeBuilding: {
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeBuilding", true);
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeBuildingPublic", true);
                    break;
                }
                case LhlpRecordSubType.AssetTypeParkOrGarden: {
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeParkOrGarden", true);
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeParkOrGardenPublic", true);
                    break;
                }
                case LhlpRecordSubType.AssetTypeLandmarkOrArtwork: {
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeLandmarkOrArtwork", true);
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeLandmarkOrArtworkPublic", true);
                    break;
                }
                case LhlpRecordSubType.AssetTypeOtherSiteStructure: {
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeOtherSiteStructure", true);
                    this.mapStore.onLayerVisibiltyChanged("AssetTypeOtherSiteStructurePublic", true);
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }


    private initialiseStatusFilters = (): void => {

        // if we have hidden the filter panel (which happens because only one valid status is present in the data)
        // then never let that hidden layer be de-selected because there's no way to switch it on again
        if ($('#extraPanelOverlays').css('display') != 'none') {

            // otherwise load selected statuses from mapstore memory
            let selectedStatuses = this.storage.getArray(this.mfOptions.mapStoreKey.concat("_StatusFilters")) as Array<number>

            // but - specially - also look for a Status that has been passed in
            // because we need to scroll to a specified asset and in this case enable its status regardless
            // and save that enablement
            let assetStatusId: number = + $('#scrollToAssetStatus').val();
            if (!isNaN(assetStatusId) && assetStatusId > 0) {
                if (selectedStatuses != undefined && selectedStatuses.length > 0) {
                    if (selectedStatuses.indexOf(assetStatusId) == -1)
                        selectedStatuses.push(assetStatusId);
                }
                else { selectedStatuses = [assetStatusId]; }
            }

            // now set the checkboxes according to what we now think should be the selected statuses.
            // The loader picks these up later when deciding which assets to load
            if (selectedStatuses != undefined && selectedStatuses.length > 0) {
                document.querySelectorAll('.StatusFilter').forEach((elem) => {
                    let cb_statusItem = elem as HTMLInputElement;
                    let statusId: number = + cb_statusItem.getAttribute('data-status-id');
                    if (selectedStatuses.includes(statusId))
                        cb_statusItem.checked = true;
                    else
                        cb_statusItem.checked = false;
                });
            }

            // we may now need to save them back again, since we might have modified them
            this.storeStatusFilters();
        }
    }

    private applyStatusFilters = (): void => {
        let vlgs = this.layerGroups.vectorLayerGroups;

        vlgs.forEach((lg) =>
            lg.reLoadLayers()  // same as calling .source.source.refresh on each of the layers individually
        );
    }

    private storeStatusFilters = (): void => {
        let statusFilters: Array<number> = [];
        document.querySelectorAll('.StatusFilter').forEach((elem) => {
            if ((elem as HTMLInputElement).checked) {
                statusFilters.push(+ (elem as HTMLInputElement).getAttribute('data-status-id'));
            }
        });

        // console.log('storing ' + statusFilters.length);
        this.storage.setValue(this.mfOptions.mapStoreKey.concat("_StatusFilters"), JSON.stringify(statusFilters));
    }


    private initCreateAsset = (): void => {
        let self = this;        

        //setup the buttons on the Create Asset div
        $('#mapCreateAssetBtn').on("click", function() {
            $('#mapCreateAssetBtn').hide();
            $('#mapCrossHairEnabled').show();
            $('#mapCreateAsset').css({'background-color': 'white'});
            $('#mapCentreCrosshairs').show();
        });

        $('#mapCancelAssetBtn').on("click", function() {
            $('#mapCreateAssetBtn').show();
            $('#mapCrossHairEnabled').hide();
            $('#mapCreateAsset').css({'background-color': 'transparent'});
            $('#mapCentreCrosshairs').hide();
        });
        
        $('#mapOkAssetBtn').on("click", function() {
            let mapState = self.mapStore.getMapInfo();
            let coordinate = olProj.transform(mapState.centre, 'EPSG:3857','EPSG:27700');
            let redirectUrl = self.mapConfig.CreateAssetUrl 
                + Math.floor(coordinate[0]) + '/'
                + Math.floor(coordinate[1]) + '/'
                + mapState.zoom;
            document.location.href = redirectUrl;
            return false;
        });
    }

    private setSelectedFeaturesDynamicStyle = (args: IFeaturesSelectedEventArgs): void => {
        let self = this;
        let features = args.features;
        for(let i=0;i<features.length;i++) {
            let style = this.getAssetSelectedDynamicStyle(features[i]);
            features[i].setStyle(style);
        }        
    }

    public getAssetSelectedDynamicStyle(feature: Feature): Style {
        
        let stylesConfig: LhlpMapConfig = this.mapConfig;
        let featureStatus: string   = feature.get('asset_status_id');
        if(typeof(featureStatus) == 'undefined') featureStatus = "0";  //get the default colour of listed features (stored as statusId:0 for the map legend)     
        let iconChr: string         = '\uf60e';
        let iconColour: string      = '#F00000';

        let featureGeometryType: string = feature.getGeometry().getType();

        let featureSubType: string  = feature.get('recsubtype');
        let statusStyles: Array<LhlpStatusLookup> = stylesConfig.StatusStyles;
        if(statusStyles !== null) {
            for(let statusStyle of statusStyles) {
                if(statusStyle.StatusId === featureStatus) {
                    iconColour = statusStyle.StatusColour;
                    break;
                }
            }
        }

        let typeStyles: Array<LhlpTypeLookup> = stylesConfig.TypeStyles;
        if(typeStyles !== null) {
            for(let typeStyle of typeStyles) {
                if(typeStyle.TypeId == featureSubType) {
                    let c: string = typeStyle.TypeCharacter;
                    iconChr = String.fromCharCode(parseInt(c));
                    break;
                }
            }
        }

        if(featureGeometryType === 'Point' || featureGeometryType === 'MultiPoint') {
            let text = new Text({
                text: iconChr,
                font: '900 23px "Font Awesome 6 Pro"',
                textBaseline: 'bottom',
                offsetY: 11,
                fill: new Fill({
                    color: iconColour,
                }),
                stroke: new Stroke({
                    color: 'rgba(255,255,255,1)',
                    width: 5,
                })
            });

            let style = new Style({
                image: new Circle({
                    // stroke: new Stroke({
                    //     color: 'rgba(0,0,0,0.2)', //iconColour,
                    //     width: 3
                    // }),
                    radius: 20,
                    fill: new Fill({
                        color: 'rgba(0,0,0,0.2)'
                    })
                }),
                text: text 
            });
            return style;
        }
        //polygon or multipolygon selected style
        return new Style({
            stroke: new Stroke({
                color: iconColour,
                width: 3,
            }),
            fill: new Fill({
                color: 'rgb(0,0,0,0.2)',
            }),
            image: new CircleStyle({
                radius: 5,
                fill: new Fill({
                    color: 'black',
                }),
            }),
        });

    }
    
    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {       

        let isPublic = !this.isAuthenticated();
        let layerGroups = [];

        let AssetLayerGroupConfig: Array<IVectorLayerGroupConfig> = [
            this.layerConfigFactory.layerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeBuilding, {}, isPublic),
            this.layerConfigFactory.layerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeParkOrGarden, {}, isPublic),
            this.layerConfigFactory.layerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeLandmarkOrArtwork, {}, isPublic),
            this.layerConfigFactory.layerConfig(LhlpRecordType.ASSET, LhlpRecordSubType.AssetTypeOtherSiteStructure, {}, isPublic),
        ];
        layerGroups.push({
            ref: "LHLP_Layers",
            name: "Local Heritage List - Type",
            useAccordion: true,
            expandedOnFirstLoad: true,
            layerGroupConfigs: this.filterMapLayers(AssetLayerGroupConfig)
        });

        let AreaLayerGroupConfig: Array<IWmsLayerGroupConfig> = [
            this.layerConfigFactory.layerConfig(LhlpRecordType.LocalListArea, null),
            this.layerConfigFactory.layerConfig(LhlpRecordType.LocalListSubAreas, null)
        ];
        layerGroups.push(            {
            ref: "Area_layers",
            name: "Project Areas",
            useAccordion: true,
            expandedOnFirstLoad: false,
            layerGroupConfigs: this.filterMapLayers(AreaLayerGroupConfig)
        });

        // if(!isPublic) { //issue #603 has reverted this again!
            let NHLEGroupConfig: Array<IVectorLayerGroupConfig | IWmsLayerGroupConfig> = [                        
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.ScheduledMonument),
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.ListedBuilding),                 
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.RegisteredParkAndGarden),
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.Battlefield),        
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.ProtectedWreck),
                this.layerConfigFactory.layerConfig(LhlpRecordType.NHLE, LhlpRecordSubType.WorldHeritageSite)            
            ];
            layerGroups.push({
                ref: "NHLE_layers",
                name: "NHLE",
                useAccordion: true,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(NHLEGroupConfig)
            });
        // }

        if (this.tenantSettings.MapSettings.OtherMapWMSLayers.length > 0) {

            let otherLayers = new Array<IWmsLayerGroupConfig>();

            for (let i = 0; i < this.tenantSettings.MapSettings.OtherMapWMSLayers.length; i++) {
                let wms = this.tenantSettings.MapSettings.OtherMapWMSLayers[i];

                let displayName: string = wms.LayerName

                if (wms.HelpLinkURL) {
                  displayName = this.MakeOtherWMSLayerTitleWithHelp(
                                    wms.LayerName,
                                    wms.HelpLinkURL
                                )
                }              

                let layer: IWmsLayerGroupConfig = {
                    displayName: displayName, 
                    ref: "otherLayers" + wms.WMSServerLayerNamesCSV,
                    type: wms.LayerName,
                    subType: wms.LayerName,
                    url: wms.WMSURL,
                    visibleOnFirstLoad: false,
                    info_format: "text/html",
                    layers: [
                        {
                            layerName: wms.WMSServerLayerNamesCSV,
                            minZoom: 1,
                            maxZoom: 19
                        }
                    ]
                };

                otherLayers.push(layer);
            }

            layerGroups.push({
                ref: "OtherWMSLayers",
                name: "Other layers",
                useAccordion: true,
                expandedOnFirstLoad: true,
                layerGroupConfigs: otherLayers
            });
        }

        return layerGroups;
    }


    //---------------------------------------
    // ---- Scroll to specified single asset 

    public afterLoadingFinalLayerGroup = (): void => {

        let assetId: number = + $('#scrollToAsset').val(); 
        if (!isNaN(assetId) && assetId > 0) {
            this.moveMapToFeature(assetId);
            //$('#scrollToAsset').val(0); -- no need
        }
    }

    public moveMapToFeature = (id: number): void => {

        let feature: Feature = null;

        let find = (): Feature => {
            for (let lg of this.layerGroups.vectorLayerGroups) {
                for (let l of lg.layers) {
                    let f = l.olVectorLayer.getSource().getFeatureById(id);
                    if (f !== null) {
                        return f;
                    }
                }
            }
            return null;
        };

        feature = find();

        if (feature !== null) {

            this.selectedSingleAsset = feature;

            let status: number = + feature.getProperties()["asset_status_id"];
            // jk - we could perhaps try to enable this status if it's currently off...
            // todo later.

            if (!this.singleAssetSelected) {
                let style = this.getAssetSelectedDynamicStyle(feature);
                let cloneStyle = style.clone(); // not sure if cloning required here, feels safer -jk
                let im = new Circle({
                    stroke: new Stroke({
                        color: 'rgba(0,0,0,0.9)',
                        width: 2
                    }),
                    radius: 24,
                    fill: new Fill({
                        color: 'rgba(250,0,0,0.7)'
                    })
                });
                cloneStyle.setImage(im);
                feature.setStyle(cloneStyle);

                let extent = feature.getGeometry().getExtent();

                //var centre = olExtent.getCenter(extent);
                //this.map.olMap.getView().animate({ center: centre });
                this.map.olMap.getView().fit(extent, { duration: 1000, maxZoom: 19 });

                // jk - I can't really see how to make this feature 'selected' in the sense that we
                // open sidepanel with the infoclick data in it for just this one.
                // maybe something like reimplementing MapFeatureInfo.createFeatureListHtml
                // 
                //$('#featureInfo').children().remove();
                //$('#featureInfo').append("<ul><li>thing</li></ul>");
                //if (!$("#slide-panel-info").is(':visible')) {
                //    $("#slide-panel-btn-info").click(); }

                this.singleAssetSelected = true;
            }
            else {
                // make the selected style less persistent
                this.revertStyle(feature);
            }
        }
        else {
            if (!this.singleAssetSelected)
                $('#FailedToFindSingleAsset').modal('show');
        }
    }

    // probably clumsy way of getting rid of selected scrolled-to special feature style
    private revertStyle = (feature: Feature): void => {
        let style = this.getAssetSelectedDynamicStyle(feature);
        let cloneStyle = style.clone(); // not sure if cloning required here, feels safer -jk
        let im = new Circle({
            stroke: new Stroke({
                color: 'rgba(0,0,0,0)',
                width: 2
            }),
            radius: 24,
            fill: new Fill({
                color: 'rgba(0,0,0,0)'
            })
        });
        cloneStyle.setImage(im);
        feature.setStyle(cloneStyle);
    }


    //******************************************************************************************************************************** */
    //OTHER WMS Layers
    private MakeOtherWMSLayerTitleWithHelp = (layerName: string, layerHelpUrl: string): string => {
        let displayName: string = layerName;
        let helpIcon: string = `<i title="More information about this layer..." class="fas fa-question-circle LayerHelp" data-helptext="${layerName}" data-helpurl="${layerHelpUrl}" onclick="return ShowMapLayerHelp(this)"></i>`;
        displayName += helpIcon;
        return `<span class="${layerName}">${displayName}</span>`;
    }
}


